import React, { useEffect, useState } from 'react';
import { Modal } from 'antd';

import CustomTextInput from '../CustomTextInput';
import CustomButton from '../CustomButton';

import { useSelector } from 'react-redux';
import { EditMemberOrganizationUser } from '../../redux/actions/myorganization.action';

const EditMemberOrganization = ({ visible, onClose, setEditNotificationmodal, member }) => {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [memberid, setMemberid] = useState('');

  const user = useSelector((state) => state?.Auth?.userDetails?.user);

  useEffect(() => {
    if (member) {
      setName(member.name || '');
      setEmail(member.email_address || '');
      setPhone(member.mfa_phone_number || '');
      setMemberid(member?.member_id || '');
    }
  }, [member]);

  const cancel = () => {
    onClose();
  };

  const confirmed = async () => {
    const formattedPhone = phone.replace(/[\s\-()]/g, '');
    const finalPhone = formattedPhone.startsWith('+1') ? formattedPhone : `+1${formattedPhone}`;

    const payload = {
      name,
      email_address: email,
      mfa_phone_number: finalPhone,
      member_id: memberid,
      organization_id: user.organizationid,
    };

    const res = await EditMemberOrganizationUser(payload);

    if (res?.data) {
      cancel();
      setEditNotificationmodal(true);
    }
  };

  return (
    <Modal
      className="addusermodal"
      title=""
      open={visible}
      onCancel={onClose}
      centered
      footer={null}
    >
      <h1>Edit Member</h1>
      <p>Please update the details.</p>

      <div className="add-user-main">
        <p>Full Name</p>
        <CustomTextInput
          className="inputbox"
          value={name}
          onChange={(e) => setName(e.target.value)}
        />

        <p>Email Address</p>
        <CustomTextInput
          className="inputbox"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />

        <p>Member ID</p>
        <CustomTextInput
          disabled
          className="inputbox"
          value={memberid}
          onChange={(e) => setMemberid(e.target.value)}
        />

        <p>Phone Number</p>
        <CustomTextInput
          className="inputbox"
          value={phone}
          onChange={(e) => setPhone(e.target.value)}
        />
      </div>

      <div className="btn">
        <CustomButton style={{ marginBottom: '0px' }} onClick={confirmed} text="Save" />
        <CustomButton className="cancel" style={{ marginBottom: '0px' }} onClick={cancel} text="Cancel" />
      </div>
    </Modal>
  );
};

export default EditMemberOrganization;
